var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#EEF1FA",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.875C18 8.26562 17.4844 7.75 16.875 7.75H14.8125L14.5078 7C14.3438 6.55469 13.9219 6.25 13.4531 6.25H10.5234C10.0547 6.25 9.63281 6.55469 9.46875 7L9.1875 7.75H7.125C6.49219 7.75 6 8.26562 6 8.875V15.625C6 16.2578 6.49219 16.75 7.125 16.75H16.875C17.4844 16.75 18 16.2578 18 15.625V8.875ZM14.8125 12.25C14.8125 13.8203 13.5469 15.0625 12 15.0625C10.4297 15.0625 9.1875 13.8203 9.1875 12.25C9.1875 10.7031 10.4297 9.4375 12 9.4375C13.5469 9.4375 14.8125 10.7031 14.8125 12.25ZM14.0625 12.25C14.0625 11.125 13.125 10.1875 12 10.1875C10.8516 10.1875 9.9375 11.125 9.9375 12.25C9.9375 13.3984 10.8516 14.3125 12 14.3125C13.125 14.3125 14.0625 13.3984 14.0625 12.25Z",
    fill: "#172B4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.f6becc58.svg";
export { ForwardRef as ReactComponent };